import { render } from "./DoctorApplication.vue?vue&type=template&id=63b45723&ts=true"
import script from "./DoctorApplication.vue?vue&type=script&lang=ts"
export * from "./DoctorApplication.vue?vue&type=script&lang=ts"

import "./DoctorApplication.vue?vue&type=style&index=0&id=63b45723&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__